import { render, staticRenderFns } from "./ApiNaftogazTariffmaxForm.vue?vue&type=template&id=2eec4fd0&scoped=true"
import script from "./ApiNaftogazTariffmaxForm.vue?vue&type=script&lang=js"
export * from "./ApiNaftogazTariffmaxForm.vue?vue&type=script&lang=js"
import style0 from "./ApiNaftogazTariffmaxForm.vue?vue&type=style&index=0&id=2eec4fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eec4fd0",
  null
  
)

export default component.exports